
<n-modal-background @close="$emit('close')" ref="bg">
  <n-modal-body>
    <main>
      <img class="side-image" :src="featureToUpgradeImage" />
      <div class="content">
        <div class="messages">
          <header>{{ $t(`featureRestriction.upgrades.${featureUpgrade}.title`) }}</header>
          <p class="subtitle">
            {{ $t(`featureRestriction.upgrades.${featureUpgrade}.subtitle`) }}
          </p>
          <p class="subtitle" v-if="!isAdmin">{{ $t('featureRestriction.contactAnAdminToUpgrade') }}</p>
        </div>
        <footer>
          <n-button @click="$refs.bg.close()" :label="$t('general.close')" variant="tertiary" />
          <n-button v-if="isAdmin" @click="openSalesLink()" :label="$t('general.talkToNotch')" variant="secondary" />
          <n-button v-if="showUpgradeCta" @click="upgrade()" :label="$t('general.upgrade')" />
        </footer>
      </div>
    </main>
  </n-modal-body>
</n-modal-background>
